import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

export class Autocomplete extends Component {
  constructor(props) {
    super(props)
    this.state = {
      add: false,
    }
  }

  onChange(e, value) {
    e.preventDefault()
    this.setState({ add: false })
    const val = e.target.value !== '' ? e.target.value : value
    const vals = []
    vals.push(val)
    this.props.onChange([...new Set([...this.props.defaultValues, ...vals])])
  }

  remove(e, value) {
    e.preventDefault()
    this.setState({ add: false })
    const vals = this.props.values
    vals.sort((a, b) => {
      return (
        this.props.defaultValues.indexOf(a) -
        this.props.defaultValues.indexOf(b)
      )
    })

    vals.splice(value, 1)

    this.props.onChange(vals)
  }

  render() {
    return (
      <div className={midas.formAutocomplete}>
        <div className={`${midas.formAutocompleteInput} ${midas.formInput}`}>
          {this.props.defaultValues.map((item, index) => (
            <span key={item} className={midas.chip}>
              {'Beans'}
              <button
                className={`${midas.button} ${midas.buttonClear}`}
                aria-label="Ta bort"
                onClick={e => this.remove(e, this.props.values[index])}
              />
            </span>
          ))}

          <div className={midas.formInputWrap}>
            <input className={midas.formInput} type="text" />
            <div className={midas.forceRight}>
              <i className={midas.loading} />
              <i className={midas.iconCaret} />
            </div>
          </div>
        </div>
        <ul className={midas.menu}>
          {this.props.values.map(item => (
            <li key={item.id} className={midas.menuItem}>
              <div className={midas.autocompleteTile}>
                <div className={midas.autocompleteTileContent}>{item.name}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

Autocomplete.defaultProps = {
  defaultValues: [],
}

Autocomplete.propTypes = {
  values: PropTypes.array.isRequired,
  defaultValues: PropTypes.array,
  onChange: PropTypes.func.isRequired,
}
